import * as types from './mutation-types';
import axios from 'axios';
import config from '@/config';

export const enableDesktopMode = ({ commit }) => commit(types.SET_DESKTOP_MODE, true);

export const disableDesktopMode = ({ commit }) => commit(types.SET_DESKTOP_MODE, false);

export const selectMenu = ({ commit }, menu) => commit(types.SET_MENU, menu);

export const backVersion = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`${config.API_URL}/version`)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
